import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: inherit;
`;

export const Text = styled.p<{ textColor: string }>`
  font-family: ${props => props.theme.fonts.circular} !important;
  color: ${props => props.textColor} !important;
  font-size: ${props => props.theme.fontSizes.small} !important;
  font-weight: ${props => props.theme.fontWeights.semiBold} !important;
  letter-spacing: ${props => props.theme.letterSpacings.one} !important;
  text-transform: uppercase !important;
`;
